import axios from 'axios'
import qs from 'qs'
import {
    AnonymiserDossierToString,
    CalculNbDocumentPretPourComparerOffre,
    sauterChampsPreremplis,
    TestRegexForField,
} from './Rules'
import store from './store'

const basename = '/app/me2/'

/**
    Classe dédié aux requète sur l'API SW
**/

/**
    Récupère l'objet Immo associé a une clé WAI fournie
**/
const DitConnect = (tryVal, func) => {
    tryVal += 1
    axios
        .get(basename + 'utilisateur/ditConnecte')
        .then(function (response) {
            if (response && response.data && response.data.csrf) {
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'tech_token_csrf',
                        value: response.data.csrf,
                    },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'user_id', value: response.data.id },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'user_prenom', value: response.data.prenom },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'user_nom', value: response.data.nom },
                })
                if (func) {
                    func()
                }
            } else {
                setTimeout(function () {
                    DitConnect(tryVal, func)
                }, 2000) //wait 2 seconds before continuing
            }
        })
        .catch(function (error) {
            setTimeout(function () {
                DitConnect(tryVal, func)
            }, 2000) //wait 2 seconds before continuing
            if (tryVal === 10) {
                console.error('Erreur de dit connect')
                error.name = 'Error10FailOnDitConnect'
                throw error
            }
        })
}

/**
    RecupereInfoContact
**/
const RecupereInfoContact = (tryVal, id_contact) => {
    tryVal += 1
    axios
        .get(basename + 'contact/dit?no=' + id_contact)
        .then(function (response) {
            if (response && response.data) {
                //var cc = response.data.prj_ad_cc ? response.data.prj_ad_cc : response.data.ad_cc;
                //var cp = response.data.prj_ad_cp ? response.data.prj_ad_cp : response.data.ad_cp;
                var ville = response.data.prj_ad_ville
                    ? response.data.prj_ad_ville
                    : response.data.ad_ville

                var nb_occupant = response.data.emp_nb
                var apport = response.data.fin_apport
                var mail = response.data.mel
                var tel = response.data.tel_mobile
                var nom = response.data.nom
                var prenom = response.data.prenom
                var prix_logement = response.data.prj_montant
                var type = response.data.prj_type
                var usage = response.data.prj_usage
                var ref_part = response.data.ref_part

                if (ref_part) {
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'source_ext_id', value: ref_part },
                    })
                }

                if (nom) {
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'contact_nom', value: nom },
                    })
                }
                if (prenom) {
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'contact_prenom', value: prenom },
                    })
                }

                if (tel) {
                    TestRegexForField(
                        'contact_mobile',
                        tel,
                        /^(0|(00|\+)33)[67][0-9]{8}$/
                    )
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'contact_mobile', value: tel },
                    })
                }
                if (mail) {
                    TestRegexForField(
                        'contact_mail',
                        mail,
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'contact_mail', value: mail },
                    })
                }

                if (usage) {
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'prj_usage', value: usage },
                    })
                }
                if (apport) {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'finance_apport',
                            value: parseInt(apport, 10) / 100,
                        },
                    })
                }

                if (type) {
                    store.dispatch({
                        type: 'SET',
                        value: { key: 'prj_type', value: type },
                    })
                }

                if (prix_logement) {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'prj_montant_achat',
                            value: parseInt(prix_logement, 10) / 100,
                        },
                    })
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'prj_montant_achat_validated',
                            value: true,
                        },
                    })
                }

                if (ville) {
                    RechercheCommune(ville, 1, 'prj_localisation_ville')
                }

                if (nb_occupant) {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'emp_nb_personnes_foyer',
                            value: parseInt(nb_occupant, 10),
                        },
                    })
                }

                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'origine_id_contact',
                        value: response.data.id,
                    },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_contact_status', value: 'LOADED' },
                })
            } else {
                setTimeout(function () {
                    RecupereInfoContact(tryVal, id_contact)
                }, 2000) //wait 2 seconds before continuing
            }
        })
        .catch(function (error) {
            if (tryVal === 5) {
                console.error('Erreur de chargement contact')
                error.name = 'Error5FailOnLoadingContact'
                throw error
            } else {
                setTimeout(function () {
                    RecupereInfoContact(tryVal, id_contact)
                }, 2000) //wait 2 seconds before continuing
            }
        })
}

const DitParametresApporteurImmo = () => {
    var token = store.getState().answer.tech_token_csrf

    if (token) {
        let config = {
            headers: {
                'X-CSRFToken': token,
            },
        }
        let obj = {
            'cle-wai': store.getState().answer.source_cle,
            'apporteur-code': store.getState().answer.source_apporteur_code,
        }
        axios
            .post(
                basename + 'variable-tunnel/dit-param-partenaire',
                obj,
                config
            )
            .then(function (response) {
                if (response.data) {
                    if (response.data.code && response.data.code === 'OK') {
                        if (response.data.detail != null) {
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_url_logo',
                                    value: response.data.detail['url-logo'],
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_immo_id_apporteur',
                                    value: response.data.detail.immo_id,
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_source_neuf',
                                    value: response.data.detail.uniquement_neuf,
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_nom',
                                    value: response.data.detail.nom_immo,
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_orias',
                                    value: response.data.detail.orias,
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_siren',
                                    value: response.data.detail.siren,
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_politique',
                                    value: response.data.detail[
                                        'url-politique'
                                    ],
                                },
                            })

                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_est_cgp',
                                    value: response.data.detail['est_cgp'],
                                },
                            })
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_esquive_rgpd_part_tunnel_possible',
                                    value: response.data.detail[
                                        'esquive-rgpd-part-tunnel-possible'
                                    ],
                                },
                            })

                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: 'tech_part_esquive_sms',
                                    value: response.data.detail['esquive_sms'],
                                },
                            })

                            // cas particulier Lamotte maison individuel (existe a 2 endroits : ici et dans rules avec check cle)
                            if (
                                response.data.detail.immo_id &&
                                response.data.detail.immo_id === 151
                            ) {
                                store.dispatch({
                                    type: 'SET',
                                    value: {
                                        key: 'tech_type_action_depart',
                                        value: 'estimer',
                                    },
                                })
                                store.dispatch({
                                    type: 'SET',
                                    value: {
                                        key: 'tech_esquiver_prj_type',
                                        value: true,
                                    },
                                })
                                store.dispatch({
                                    type: 'SET',
                                    value: {
                                        key: 'prj_type',
                                        value: 'TERRAIN_ET_CONSTRUCTION',
                                    },
                                })
                            }

                            // Sauter les champs pré-remplis
                            sauterChampsPreremplis(
                                response.data.detail.uniquement_neuf
                            )
                        } else {
                            sauterChampsPreremplis()
                        }
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
                setTimeout(function () {
                    DitParametresApporteurImmo()
                }, 2000) //wait 2 seconds before continuing
            })
    } else {
        setTimeout(function () {
            DitParametresApporteurImmo()
        }, 2000) //wait 2 seconds before continuing
    }
}

/**
    Retourne  un enssemble de commune correspondant au string fourni.
    Permet un préremplissage des champs Ville/CP/CC
**/
const RechercheCommune = (word, nb, linked_data_id) => {
    if (word) {
        //axios.get('/app/me2/commune/rech?'+params)
        axios
            .get(basename + 'commune/rech?q=' + word + '&nb=' + nb)
            .then(function (response) {
                //console.log(response.data )
                //console.log(response.data[0])
                if (nb === 1) {
                    // si on souhaite avoir qu'un resultat on enregistre pas le tableau de resultat mais juste la valeur
                    if (response.data && response.data[0]) {
                        const result = {
                            label:
                                response.data[0].nom +
                                ' ( ' +
                                response.data[0].cp +
                                ' )',
                            name: response.data[0].nom,
                            cp: response.data[0].cp,
                            cc: response.data[0].cc,
                            ptz: response.data[0].zone_ptz,
                        }
                        store.dispatch({
                            type: 'SET',
                            value: { key: linked_data_id, value: result },
                        })
                    }
                } else {
                    // sinon on enregistre tout le tableau
                    var cityArray = []
                    response.data.forEach((element) => {
                        cityArray = cityArray.concat({
                            label: element.nom + ' ( ' + element.cp + ' )',
                            name: element.nom,
                            cp: element.cp,
                            cc: element.cc,
                            ptz: element.zone_ptz,
                        })
                    })
                    store.dispatch({
                        type: 'SET',
                        value: { key: linked_data_id, value: cityArray },
                    })
                }
            })
            .catch(function (error) {
                console.error('Erreur de RechercheCommune avec le mot:' + word)
                console.error(
                    'Erreur de recherche commune, error message : ' +
                        JSON.stringify(error.response)
                )
                error.name = 'ErrorRechercheCommune' + error.response.status
                throw error
            })
    }
}

/**
    Retourne l'eligibilite PTZ du projet en cours
**/
const EligibilitePtz = (
    type_projet,
    nombre_occupant,
    revenu_fiscaux,
    travaux,
    cout_operation,
    zone,
    type_log
) => {
    store.dispatch({
        type: 'SET',
        value: { key: 'tech_loading_ptz', value: true },
    })

    axios({
        method: 'post',
        url: '/function/ptz',
        data: {
            zone: zone,
            type_projet: type_projet,
            type_log: type_log,
            nombre_occupant: nombre_occupant,
            revenu_fiscaux: revenu_fiscaux,
            travaux: travaux,
            cout_operation: cout_operation,
        },
        headers: {
            'content-type': 'application/json;charset=utf-8',
        },
    })
        .then(function (response) {
            console.log(response)
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_loading_ptz', value: false },
            })
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_result_ptz', value: response.data },
            })
        })
        .catch(function (error) {
            console.log(error)
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_loading_ptz', value: false },
            })
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_result_ptz', value: error },
            })
        })
}

/**
   demande si un controle du numéro de téléphone doit étre réalisé
**/
const ControleTel = (tryVal, token, mail, mobile, func) => {
    tryVal += 1
    axios({
        method: 'post',
        url: basename + 'controletel/estNecessaire',
        data: qs.stringify({
            mel: mail,
            tel_mobile: mobile,
        }),
        headers: {
            'X-CSRFToken': token,
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
    })
        .then(function (response) {
            //console.log(response.data )
            if (response.data) {
                if (
                    response.data.code &&
                    response.data.code === 'DEJA_VALIDE'
                ) {
                    if (func) {
                        func()
                    }
                } else if (
                    response.data.code &&
                    response.data.code === 'A_CONTROLER'
                ) {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'tech_mobile_client_id',
                            value: response.data.client_id,
                        },
                    })
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'tech_mobile_num_a_valider',
                            value: true,
                        },
                    })
                    ControleTelEnvoyerCode(
                        0,
                        token,
                        response.data.client_id,
                        mobile
                    )
                } else if (
                    response.data.code &&
                    response.data.code === 'INCORRECT'
                ) {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'tech_mobile_client_id',
                            value: null,
                        },
                    })
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'tech_mobile_num_a_valider',
                            value: null,
                        },
                    })
                }
            }
        })
        .catch(function (error) {
            console.log(error)
            if (error.response != null) {
                if (error.response.status === 403 && tryVal < 3) {
                    // si erreur 403 et pas 3 essaie réalisé --> surement un soucis de mauvais token , on retry des demandes de token,
                    // si ok sur dit connect ( nouveau token ) on recall cette méthode
                    var ControlTelAgain = function () {
                        ControleTel(tryVal, token, mail, mobile, func)
                    }
                    DitConnect(0, ControlTelAgain)
                } else if (error.response.status === 422 && tryVal < 3) {
                    ControleTel(tryVal, token, mail, mobile, func)
                } else {
                    console.error(
                        "Erreur de Controle Telephone numero'" +
                            mobile +
                            "' et mail '" +
                            mail +
                            "' error message : " +
                            JSON.stringify(error.response)
                    )
                    error.name = 'ErrorControleTel' + error.response.status
                    throw error
                }
            }
        })
}

/**
    demande un envoi de code SMS
**/
const ControleTelEnvoyerCode = (tryVal, token, client_id, mobile) => {
    tryVal += 1
    store.dispatch({
        type: 'SET',
        value: { key: 'tech_mobile_relance_code_ok', value: false },
    })
    axios({
        method: 'post',
        url: basename + 'controletel/envoyerCode',
        data: qs.stringify({
            client_id: client_id,
            tel_mobile: mobile,
        }),
        headers: {
            'X-CSRFToken': token,
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
    })
        .then(function (response) {
            //console.log(response.data )
            if (response.data) {
                if (response.data.code && response.data.code === 'OK') {
                    setTimeout(function () {
                        store.dispatch({
                            type: 'SET',
                            value: {
                                key: 'tech_mobile_relance_code_ok',
                                value: true,
                            },
                        })
                    }, 10000) //wait ten seconds before continuing
                } else {
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'tech_mobile_relance_code_ok',
                            value: true,
                        },
                    })
                }
            }
        })
        .catch(function (error) {
            if (error.response.status === 422 && tryVal < 3) {
                ControleTelEnvoyerCode(tryVal, token, client_id, mobile)
            } else {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_mobile_relance_code_ok', value: true },
                })
                console.error(
                    "Erreur de demande d'envoi de code SMS  au numéro:" +
                        mobile +
                        '  error message : ' +
                        JSON.stringify(error.response)
                )
                error.name = 'ErrorTelEnvoyerCode' + error.response.status
                throw error
            }
        })
}

/**
    vérifie un code SMS
**/
const ControleTelWithValidationString = (
    token,
    code_sms,
    client_id,
    mobile,
    func
) => {
    axios({
        method: 'post',
        url: basename + 'controletel/validerCode',
        data: qs.stringify({
            client_id: client_id,
            code_sms: code_sms,
            tel_mobile: mobile,
        }),
        headers: {
            'X-CSRFToken': token,
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
    })
        .then(function (response) {
            if (response.data.code && response.data.code === 'OK') {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_mobile_num_a_valider', value: false },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_mobile_code_errone', value: false },
                })
                func()
            } else if (response.data.code && response.data.code === 'KO') {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_mobile_code_errone', value: true },
                })
            }
        })
        .catch(function (error) {
            console.error(
                "Erreur de Controle Telephone numero'" +
                    mobile +
                    "' et client_id '" +
                    client_id +
                    "' et code_sms '" +
                    code_sms +
                    ' error message : ' +
                    JSON.stringify(error.response)
            )
            error.name = 'ErrorVerificationCodeSMS' + error.response.status
            throw error
        })
}

const EnrTunnelTemp = (obj, token) => {
    let config = {
        headers: {
            'X-CSRFToken': token,
        },
    }
    if (obj) {
        axios
            .post(basename + 'tunneltemp', obj, config)
            .then(function (response) {
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'id_temp_tunnel',
                        value: response.data.detail,
                    },
                })
            })
            .catch(function (error) {
                //Erreur non bloquante pour la suite
            })
    }
    return
}

const SupprimerTunnelTemp = (id, token) => {
    let config = {
        headers: {
            'X-CSRFToken': token,
        },
    }
    if (id) {
        axios
            .delete(basename + 'tunneltemp?id=' + id, null, config)
            .then(function (response) {})
            .catch(function (error) {
                //Erreur non bloquante pour la suite
            })
    }
    return
}

/**
    EndPoint permettant de déposer un dossier client avec une maturité TROUVER.
**/
const EnregistrerDossierTrouver = (dossierObj, token) => {
    let config = {
        headers: {
            'X-CSRFToken': token,
        },
    }
    if (dossierObj) {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_enr_dossier_status', value: 'LOAD' },
        })
        axios
            .post(basename + 'trouver-meilleur-pret', dossierObj, config)
            .then(function (response) {
                //console.trace('TrouverMeilleurPret response', {response});
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_enr_dossier_status', value: 'SEND' },
                })
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'resultat_no_dossier',
                        value: response.data.detail['numero-dossier'],
                    },
                })
                SupprimerTunnelTemp(store.getState().answer.id_temp_tunnel)
                setTimeout(function () {
                    if (window.location === window.parent.location) {
                        console.log('redirection automatique car non iframed')
                        window.location.replace(
                            window.location.origin +
                                '/projet#!/estimations?no=' +
                                response.data.detail['numero-dossier']
                        )
                    }
                }, 2000) //wait 2 seconds before continuing
            })
            .catch(function (error) {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_enr_dossier_status', value: 'ERR' },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_enr_dossier_erreur', value: error },
                })
                console.error(
                    "Erreur d'enregistrement dossier Trouver, error message:" +
                        JSON.stringify(error.response)
                )
                console.error(AnonymiserDossierToString(dossierObj))
                error.name = 'Error' + error.response.status
                throw error
            })
    }
    return
}

const EstimerFraisNotaire = (prix, projetType, linked_data_id) => {
    if (prix) {
        let config = {
            headers: {
                'content-type': 'application/json;charset=utf-8',
            },
        }

        let input = axios({
            method: 'get',
            url:
                basename +
                'frais_notaire?prj_type=' +
                projetType +
                '&prix_logement=' +
                prix * 100,
            headers: {
                'content-type': 'application/json;charset=utf-8',
            },
        })
            .then(function (response) {
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: linked_data_id,
                        value: Math.round(response.data.detail / 100),
                    },
                })
            })
            .catch(function (error) {
                console.error('Problème lors du calcul des frais de notaire')
                error.name = 'Error' + error.response.status
                throw error
            })
    } else {
        store.dispatch({
            type: 'SET',
            value: { key: linked_data_id, value: 0 },
        })
    }
    return
}

/**
    EndPoint permettant de déposer un dossier client avec une maturité en RECHERCHE.
**/
const EnregistrerDossierRecherche = (dossierObj, token) => {
    let config = {
        headers: {
            'X-CSRFToken': token,
        },
    }
    if (dossierObj) {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_enr_dossier_status', value: 'LOAD' },
        })
        axios
            .post(
                basename + 'evaluer-capacite-emprunt/depot-dossier',
                dossierObj,
                config
            )
            .then(function (response) {
                //console.trace({response});
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_enr_dossier_status', value: 'SEND' },
                })
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'resultat_no_dossier',
                        value: response.data.detail['numero-dossier'],
                    },
                })
                if (
                    response.data.detail['affected-calendly'] !== undefined &&
                    response.data.detail['affected-calendly'] !== ''
                )
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'resultat_affected_calendly',
                            value: response.data.detail['affected-calendly'],
                        },
                    })
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'resultat_affected_name',
                        value: response.data.detail['affected-name'],
                    },
                })
                SupprimerTunnelTemp(store.getState().answer.id_temp_tunnel)
            })
            .catch(function (error) {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_enr_dossier_status', value: 'ERR' },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_enr_dossier_erreur', value: error },
                })
                console.error(
                    "Erreur d'enregistrement dossier Recherche, error message :" +
                        JSON.stringify(error.response)
                )
                console.error(AnonymiserDossierToString(dossierObj))
                error.name = 'Error' + error.response.status
                throw error
            })
    }
    return
}

/**
    EndPoint permettant de déposer un dossier client avec une maturité en RECHERCHE.
**/
const CalculMaxEmpruntable = (dossierObj, token) => {
    let config = {
        headers: {
            'X-CSRFToken': token,
        },
    }
    if (dossierObj) {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_affichage_max_emp', value: 'LOAD' },
        })
        axios
            .post(
                basename + 'evaluer-capacite-emprunt/evaluation',
                dossierObj,
                config
            )
            .then(function (response) {
                //console.trace({response});
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_affichage_max_emp', value: 'OK' },
                })
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'resultat_evaluation_max_empruntable',
                        value: response.data.detail,
                    },
                })
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'resultat_evaluation_alerts',
                        value: response.data.detail.alertes,
                    },
                })
            })
            .catch(function (error) {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_affichage_max_emp', value: 'ERR' },
                })
                console.error(
                    'Erreur calcul max empruntable, error message :' +
                        JSON.stringify(error.response)
                )
                console.error(AnonymiserDossierToString(dossierObj))
                error.name = 'Error' + error.response.status
                throw error
            })
    }
    return
}

const EnvoiFichierComparerOffre = (fichier, token) => {
    if (fichier) {
        var formData = new FormData()
        formData.append('file', fichier)
        let config = {
            headers: {
                'X-CSRFToken': token,
                'Content-Type': 'multipart/form-data',
            },
        }
        axios
            .post(basename + 'comparer-offre/doc', formData, config)
            .then(function (response) {
                //console.log(response);
                if (
                    response.data.code === 'OK' &&
                    response.data.detail &&
                    response.data.detail.uuid
                ) {
                    fichier.etat_envoi = 'SEND'
                    fichier.uuid = response.data.detail.uuid
                } else {
                    fichier.etat_envoi = 'ERR'
                    fichier.uuid = ''
                }
                var newState = store
                    .getState()
                    .answer.files.filter(
                        (existingFile) => existingFile.name !== fichier.name
                    )
                newState.push(fichier)
                store.dispatch({
                    type: 'SET',
                    value: { key: 'files', value: newState },
                })
                CalculNbDocumentPretPourComparerOffre(newState)
            })
            .catch(function (error) {
                fichier.etat_envoi = 'ERR'
                fichier.uuid = ''
                var newState = store
                    .getState()
                    .answer.files.filter(
                        (existingFile) => existingFile.name !== fichier.name
                    )
                newState.push(fichier)
                store.dispatch({
                    type: 'SET',
                    value: { key: 'files', value: newState },
                })
                console.error(
                    "Erreur d'envoi de fichier error message : " +
                        JSON.stringify(error.response)
                )
                error.name = 'Error' + error.response.status
                throw error
            })
    }
    return
}

const ComparerOffre = (offre, token) => {
    if (offre) {
        let config = {
            headers: {
                'X-CSRFToken': token,
            },
        }
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_env_offre_status', value: 'LOAD' },
        })
        axios
            .post(basename + 'comparer-offre', offre, config)
            .then(function (response) {
                //console.log(response);
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_env_offre_status', value: 'SEND' },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_env_offrer_ok', value: response.data },
                })
            })
            .catch(function (error) {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_env_offre_status', value: 'ERR' },
                })
                store.dispatch({
                    type: 'SET',
                    value: { key: 'tech_env_offre_erreur', value: error },
                })
                console.error("Erreur d'enregistrement de comparaison d'offre")
                console.error(AnonymiserDossierToString(offre))
                error.name = 'Error' + error.response.status
                throw error
            })
    }
    return
}

const DitMessagePtz = (func) => {
    axios
        .get(basename + 'param/ditParamPublic')
        .then(function (response) {
            if (response && response.data && response.data.message_alerte_ptz) {
                store.dispatch({
                    type: 'SET',
                    value: {
                        key: 'message_alerte_ptz',
                        value: response.data.message_alerte_ptz,
                    },
                })
                if (func) {
                    func()
                }
            }
        })
        .catch(function (error) {
            console.log(
                "Erreur lors de la récupération d'un paramètre, non bloquant"
            )
        })
}

export {
    DitConnect,
    DitParametresApporteurImmo,
    RechercheCommune,
    EligibilitePtz,
    ControleTel,
    ControleTelWithValidationString,
    ControleTelEnvoyerCode,
    EnregistrerDossierTrouver,
    EnregistrerDossierRecherche,
    CalculMaxEmpruntable,
    EnvoiFichierComparerOffre,
    ComparerOffre,
    RecupereInfoContact,
    EstimerFraisNotaire,
    EnrTunnelTemp,
    DitMessagePtz,
}
